module.exports = require('./helpers/bundle-url').getBundleURL('ljLQj') + "logo.c51670a8.svg";